<template>
  <div class="box">
    <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/404.svg"/>
    <span>该页面不存在 <br/>或无权访问 <br/>请检查后重试</span>
    <button @click="goHome" class="home">前往首页</button>
  </div>
</template>
<script>
import { goHomePath } from '../../utils/power'
export default {
  beforeRouteEnter (to, from, next) {
    if (from.name === 'ExerlandLogin' && to.name === '404') {
      window.location.href = to.path
      // next(vm => {
      //   vm.$router.go()
      // })
    } else {
      next()
    }
  },
  methods: {
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  img {
    width: 149px;
    height: 144px;
  }
  span {
    margin-top: 44px;
    display: block;
    width:192px;
    font-size:16px;
    text-align: center;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(136,136,136,1);
  }
  button {
    width:132px;
    height:44px;
    background:rgba(24,204,159,1);
    border-radius:4px;
    font-size:17px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:24px;
    border: none;
    outline: none;
    margin-top: 39px;
  }
  .home {
    background:rgba(245,245,245,1);
    color:rgba(0,0,0,1);
    margin-top: 18px;
  }
}
</style>
